import React from 'react'
export default class StepDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.updateResult = this.props.updateResult;

    this.state = { answerValue: this.props.initialResult };
  }

  onChange = (event) => {
    const { itemDestinationName } = this.props.options;

    const { answerValue } = this.state;
    let answer = answerValue ? answerValue : {};
    answer[itemDestinationName] = event.target.value;

    this.setState({ answerValue: answer });
    this.updateResult(
      true,
      itemDestinationName,
      event.currentTarget.value
    );
  }

  render() {
    const {
      possibleChoices,
      itemLabel,
      defaultValue,
      errorMessage,
      itemDestinationName
    } = this.props.options;

    const {
      viewErrors,
      canGoToNextStep
    } = this.props;

    const { answerValue } = this.state;
    const currentAnswer = answerValue && answerValue[itemDestinationName] ? answerValue[itemDestinationName] : defaultValue;

    if (!canGoToNextStep && currentAnswer !== defaultValue) {
      this.updateResult(
        true
      );
    }

    return (
      <div className="tab">
        <div className="question">{itemLabel}</div>
        <div className="form-select auto-mt-xs is-filled" data-dc-component="form-field" data-form-control="">
          <select
            className="form-select__select"
            id="PersonalData_Title"
            name="PersonalData.Title"
            required="required"
            value={currentAnswer}
            onChange={this.onChange}
          >
            <option
              className="form-select__option"
              disabled="disabled"
              value={defaultValue}
            >
              {defaultValue}
            </option>
            {possibleChoices.map((option, index) => {
              return (
                <option
                  key={index}
                  className="form-select__option"
                  value={option}
                >
                  {option}
                </option>
              );
            })}
          </select>
          <svg aria-hidden="true" focusable="false" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="chevron-dropdown">
            <path fill="" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path>
          </svg>
        </div>
        {viewErrors && currentAnswer === defaultValue ? <ul className="form-field__error-list filled">
          <li className="form-field__error-item">{errorMessage}</li>
        </ul> : null}
      </div >
    )
  }
}